"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _escapeRegExp = require("lodash/escapeRegExp");

var _escapeRegExp2 = _interopRequireDefault(_escapeRegExp);

var _getTextFromNode = require("../../helpers/getTextFromNode");

var _getTextFromNode2 = _interopRequireDefault(_getTextFromNode);

var _multiselectHelpers = require("../multiselectHelpers");

var _tokens = require("../../helpers/tokens.json");

var _tokens2 = _interopRequireDefault(_tokens);

var _ErrorMessage = require("../../__beta__/ErrorMessage/ErrorMessage");

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

var _Icon = require("../../Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _RawButton = require("../../RawButton");

var _RawButton2 = _interopRequireDefault(_RawButton);

var _OutsideClickWrapper = require("../../OutsideClickWrapper");

var _OutsideClickWrapper2 = _interopRequireDefault(_OutsideClickWrapper);

var _TriggerSelectCount = require("../TriggerSelect/TriggerSelectCount/TriggerSelectCount");

var _TriggerSelectCount2 = _interopRequireDefault(_TriggerSelectCount);

var _FilterField = require("../FilterField/FilterField");

var _FilterField2 = _interopRequireDefault(_FilterField);

var _CheckableList = require("../CheckableList/CheckableList");

var _CheckableList2 = _interopRequireDefault(_CheckableList);

var _Divider = require("../Divider/Divider");

var _Divider2 = _interopRequireDefault(_Divider);

var _MultiselectItem = require("../MultiselectItem");

var _MultiselectItem2 = _interopRequireDefault(_MultiselectItem);

var _customPropTypes = require("../../helpers/customPropTypes");

require("../Multiselect.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var filterHeight = 48;
var triggerHeight = 34;
var minWidth = 120;
var minHeight = 180;
var defaultHeight = 320;

var SingleselectWithSections = function (_Component) {
  _inherits(SingleselectWithSections, _Component);

  function SingleselectWithSections(props) {
    _classCallCheck(this, SingleselectWithSections);

    var _this = _possibleConstructorReturn(this, (SingleselectWithSections.__proto__ || Object.getPrototypeOf(SingleselectWithSections)).call(this, props));

    _this.setSingleselectRef = function (component) {
      _this.$singleselect = component;
    };

    _this.setTriggerSelectRef = function (component) {
      _this.props.triggerRef(component);
      _this.$triggerSelect = component;
    };

    _this.setFilterFieldRef = function (component) {
      _this.$filterField = component;
    };

    _this.minimizeSelect = function () {
      if (_this.props.isCollapsible && _this.state.isExpanded) {
        _this.setState({ isExpanded: false });
      }
    };

    _this.maximizeSelect = function () {
      if (!_this.state.isExpanded) {
        _this.shouldFocus = true;
        _this.setState({ isExpanded: true });
      }
    };

    _this.toggleSelect = function () {
      if (_this.state.isExpanded) {
        _this.minimizeSelect();
      } else {
        _this.maximizeSelect();
      }
    };

    _this.handleOutsideClick = function () {
      _this.minimizeSelect();
    };

    _this.handleEscapeKey = function () {
      _this.minimizeSelect();
    };

    _this.handleClear = function () {
      _this.props.onClear();
      if (_this.props.isCollapsible) {
        _this.$triggerSelect.focus();
      }
    };

    _this.handleClickItem = function (_ref, sectionId) {
      var itemId = _ref.itemId;

      _this.props.onClickItem(_this.visibleItems[itemId], sectionId);
      _this.minimizeSelect();
      if (_this.props.isCollapsible) {
        _this.$triggerSelect.focus();
      }
    };

    _this.handleSubmitFilterField = function (filterValue) {
      if (_this.props.validateInput(filterValue)) {
        _this.props.onSubmitFilterString(filterValue);
        _this.minimizeSelect();
      } else {
        _this.setState({ showInlineError: true });
      }
    };

    _this.handleChangeFilterField = function (str) {
      _this.setState({ showInlineError: false });
      _this.props.onChangeFilterString(str);
    };

    _this.itemMatchesFilter = function (item) {
      if (!_this.props.filterString) return true;
      var filterRegExp = new RegExp((0, _escapeRegExp2.default)(_this.props.filterString), "gi");
      return filterRegExp.length === 0 || (0, _getTextFromNode2.default)(item.content).match(filterRegExp) || item.title.match(filterRegExp);
    };

    _this.shouldHandleOutsideClick = function () {
      return _this.state.isExpanded;
    };

    _this.renderItem = function (item) {
      var id = item.id;

      _this.visibleItems[id] = item;
      return _react2.default.createElement(_MultiselectItem2.default, _extends({}, item, { key: id }));
    };

    _this.renderSection = function (section, i) {
      return _react2.default.createElement(
        "div",
        { key: "section-" + i },
        _react2.default.createElement(_Divider2.default, { key: "divider-" + i, text: section.heading, align: _this.props.dividerAlignment }),
        _react2.default.createElement(_CheckableList2.default, {
          handleSelection: function handleSelection(item) {
            return _this.handleClickItem(item, i);
          },
          isDisabled: _this.props.isDisabled,
          isMultiselectable: false,
          key: "checkable-list-" + i,
          list: section.items
        })
      );
    };

    _this.renderClearButton = function () {
      if (!_this.props.showClear || _this.props.isDisabled || _this.props.isPending || _this.props.isReadOnly || !_this.props.value) {
        return null;
      }
      return _react2.default.createElement(
        _RawButton2.default,
        {
          ariaLabel: _this.props.clearText,
          className: "triggerselect__clear-button",
          isDisabled: _this.props.isDisabled,
          onClick: _this.handleClear
        },
        _react2.default.createElement(_Icon2.default, { type: "times-circle", size: 14, color: _tokens2.default.textColor.icon })
      );
    };

    _this.state = {
      isExpanded: !props.isCollapsible,
      showInlineError: false
    };
    _this.visibleItems = {};
    _this.shouldFocus = false;
    return _this;
  }

  _createClass(SingleselectWithSections, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.shouldFocus && this.$filterField) {
        this.$filterField.focus();
        this.shouldFocus = false;
      }
    }
  }, {
    key: "getHeightStyle",
    value: function getHeightStyle() {
      var offset = triggerHeight;
      var height = this.props.height ? Math.max(this.props.height, minHeight) : defaultHeight;
      if (this.props.showFilter) {
        offset += filterHeight;
      }
      return _defineProperty({}, this.props.isCollapsible ? "maxHeight" : "height", height - offset + "px");
    }
  }, {
    key: "getWidthStyle",
    value: function getWidthStyle() {
      return this.props.width >= minWidth ? { width: this.props.width + "px" } : null;
    }
  }, {
    key: "renderFilterField",
    value: function renderFilterField() {
      if (!this.props.showFilter) return null;
      return _react2.default.createElement(_FilterField2.default, {
        hasError: this.state.showInlineError,
        isDisabled: this.props.isDisabled,
        onChange: this.handleChangeFilterField,
        onEnter: this.handleSubmitFilterField,
        onEscape: this.handleEscapeKey,
        placeholderText: this.props.filterPlaceholder,
        inputRef: this.setFilterFieldRef,
        value: this.props.filterString
      });
    }
  }, {
    key: "renderItemsAndDividers",
    value: function renderItemsAndDividers() {
      var _this2 = this;

      var itemsAndDivider = this.props.sections.map(function (section) {
        return _extends({}, section, {
          items: section.items.filter(_this2.itemMatchesFilter).map(_this2.renderItem)
        });
      }).filter(function (section) {
        return section.items.length > 0;
      }).map(this.renderSection);

      return itemsAndDivider.length ? itemsAndDivider : _react2.default.createElement(
        "div",
        { className: "aclui-multiselect__no-results" },
        this.props.noResultsText
      );
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      if (!this.state.isExpanded) return null;

      if (this.props.errorMessage) {
        return _react2.default.createElement(
          "div",
          { className: "aclui-multiselect__body", ref: this.setMultiselectRef },
          _react2.default.createElement(
            _ErrorMessage2.default,
            { style: this.getHeightStyle() },
            this.props.errorMessage
          )
        );
      }

      return _react2.default.createElement(
        "div",
        { className: "aclui-multiselect__body", ref: this.setSingleselectRef },
        this.renderFilterField(),
        _react2.default.createElement(
          "div",
          { className: "aclui-multiselect__scrolling-area", role: "listbox", style: this.getHeightStyle() },
          this.renderItemsAndDividers()
        )
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          ariaText = _props.ariaText,
          canTriggerPropagate = _props.canTriggerPropagate,
          className = _props.className,
          isCollapsible = _props.isCollapsible,
          isDisabled = _props.isDisabled,
          isPending = _props.isPending,
          isReadOnly = _props.isReadOnly,
          placeholderText = _props.placeholderText,
          showClear = _props.showClear,
          value = _props.value,
          size = _props.size;

      var ariaTitle = value ? value.title : placeholderText;
      var rootClasses = (0, _classnames2.default)("aclui-multiselect aclui-multiselect--singleselect", className, "aclui-multiselect--" + size, { "is-disabled": isDisabled }, { "aclui-multiselect--has-no-selection": !value }, { "aclui-multiselect--is-always-open": !isCollapsible });

      return _react2.default.createElement(
        _OutsideClickWrapper2.default,
        {
          className: "aclui-multiselect__outside-click-wrapper",
          onOutsideClick: this.handleOutsideClick,
          shouldOutsideClick: this.shouldHandleOutsideClick,
          style: this.getWidthStyle()
        },
        _react2.default.createElement(
          "div",
          { className: rootClasses },
          _react2.default.createElement(_TriggerSelectCount2.default
          // TODO: add i18n or L10n
          , { ariaLabel: (0, _multiselectHelpers.getSelectAriaLabel)("Single", ariaTitle, ariaText, isReadOnly),
            canPropagate: canTriggerPropagate,
            className: showClear ? "has-clear-button" : "",
            isDisabled: isDisabled,
            isDisplayOnly: !isCollapsible,
            isExpanded: this.state.isExpanded,
            isPending: isPending,
            isReadOnly: isReadOnly,
            onClick: this.toggleSelect,
            renderTrigger: this.props.renderTrigger,
            statusTitle: value && value.title || placeholderText,
            triggerRef: this.setTriggerSelectRef,
            size: size
          }),
          this.renderClearButton(),
          this.renderBody()
        )
      );
    }
  }]);

  return SingleselectWithSections;
}(_react.Component);

var itemShape = {
  content: _propTypes2.default.node,
  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  title: _propTypes2.default.string.isRequired
};

var sectionShape = {
  heading: _propTypes2.default.string.isRequired,
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape(itemShape)).isRequired
};

SingleselectWithSections.propTypes = {
  /** The ARIA label for the toggle button. */
  ariaText: _propTypes2.default.string,

  /** If the click event on the trigger can propagate. */
  canTriggerPropagate: _propTypes2.default.bool,

  /** Custom class names. */
  className: _propTypes2.default.string,

  /** Aria text for the remove (X) button. */
  clearText: _propTypes2.default.string,

  /** Alignment for section dividers */
  dividerAlignment: _propTypes2.default.string,

  /** Content for an error message. */
  errorMessage: _propTypes2.default.node,

  /** Placeholder text that appears in the filter input field. */
  filterPlaceholder: _propTypes2.default.string,

  /** Value of the text search filter field. */
  filterString: _propTypes2.default.string,

  /** Maximum height of the dropdown body / scrolling area. */
  height: _propTypes2.default.number,

  /** The inline error message to display if they submit a filterString that causes validateInput() to return false */
  invalidInputErrorMessage: _propTypes2.default.string,

  /** If the component is displayed like a typical <select> form element. */
  isCollapsible: _propTypes2.default.bool,

  /** If the component is disabled. */
  isDisabled: _propTypes2.default.bool,

  /** If the component is pending or waiting for something. */
  isPending: _propTypes2.default.bool,

  /** If the component is read only. */
  isReadOnly: _propTypes2.default.bool,

  /** Placeholder text when the applied filter returns no results. */
  noResultsText: _propTypes2.default.string.isRequired,

  /** Function to call when value of filter field changes. */
  onChangeFilterString: _propTypes2.default.func,

  /** Function to call when they press 'enter' on the filter field. */
  onSubmitFilterString: _propTypes2.default.func,

  /** Function to call when the clear button is clicked. */
  onClear: _propTypes2.default.func,

  /** Function to call when an item is clicked. */
  onClickItem: _propTypes2.default.func,

  /** Text for Trigger / Status bar when there is no selection. */
  placeholderText: _propTypes2.default.string.isRequired,

  /** Render prop to replace multiselect trigger */
  renderTrigger: _propTypes2.default.func,

  /** List of item objects for the singleselect choices. */
  sections: _propTypes2.default.arrayOf(_propTypes2.default.shape(sectionShape)).isRequired,

  /** If the clear button should appear. */
  showClear: _propTypes2.default.bool,

  /** If the search filter should appear. */
  showFilter: _propTypes2.default.bool,

  /** Size of the dropdown button (font, height, etc). */
  size: _customPropTypes.shirtSize,

  /** A callback with the reference to the trigger component's button element. */
  triggerRef: _propTypes2.default.func,

  /** A function that runs on the value entered in the filterString when they press 'enter', and returns boolean. */
  validateInput: _propTypes2.default.func,

  /** The selected value. */
  value: _propTypes2.default.shape(itemShape),

  /** Sets the width (in pixels) of the component (default is 100% / must be at least 120). */
  width: _propTypes2.default.number
};

SingleselectWithSections.defaultProps = {
  ariaText: null,
  className: null,
  clearText: "",
  canTriggerPropagate: false,
  dividerAlignment: "center",
  isDisabled: false,
  isPending: false,
  isReadOnly: false,
  errorMessage: null,
  filterPlaceholder: null,
  filterString: null,
  height: defaultHeight,
  invalidInputErrorMessage: "",
  isCollapsible: true,
  onChangeFilterString: function onChangeFilterString() {},
  onClear: function onClear() {},
  onClickItem: function onClickItem() {},
  showClear: true,
  showFilter: true,
  size: "medium",
  triggerRef: function triggerRef() {},
  validateInput: function validateInput() {
    return true;
  },
  value: null,
  width: null
};

exports.default = SingleselectWithSections;